import { Maybe } from 'types/FMSGraphqlTypes'
import { TEquipmentCapabilities } from '../types'

interface IGetEquipmentTypesLabelsResult {
  preferenceLabel: string
  subLabel: string
}

export const getEquipmentTypesLabels = (
  equipmentCapabilities: Maybe<TEquipmentCapabilities>
): Maybe<IGetEquipmentTypesLabelsResult> => {
  if (!equipmentCapabilities) {
    return null
  }

  const { isDryVanCapable, isFlatbedCapable, isReeferCapable, powerUnitCount, trailerCount } =
    equipmentCapabilities || {}
  const equipmentCapabilitiesLabels = [
    ...(isDryVanCapable ? ['Dry Van'] : []),
    ...(isFlatbedCapable ? ['Flatbed'] : []),
    ...(isReeferCapable ? ['Reefer'] : []),
  ]
  return {
    preferenceLabel: equipmentCapabilitiesLabels.join(', '),
    subLabel: `${powerUnitCount} power unit${
      powerUnitCount === 1 ? '' : 's'
    }, ${trailerCount} trailer${trailerCount === 1 ? '' : 's'}`,
  }
}
